// O que o candidato pode anexar sai do próprio tipo de documento
// (DocumentType.validations), que é a mesma lista que o backend valida no upload
// (uploads/serializers.py). Sem isso a tela prometia "PDF e imagens" para tipos que só
// aceitam PDF e o candidato só descobria o erro depois de enviar o arquivo.

const FILE_TYPES = [
  { label: 'PDF', mimes: ['application/pdf'] },
  { label: 'JPG', mimes: ['application/jpg', 'application/jpeg', 'image/jpg', 'image/jpeg'] },
  { label: 'PNG', mimes: ['application/png', 'image/png'] },
];

const DEFAULT_DESCRIPTION = 'PDF e imagens (JPG e PNG)';

const parseMimes = (validations) =>
  (validations || '')
    .split(',')
    .map((mime) => mime.trim())
    .filter(Boolean);

// Valor do atributo `accept` do <input type="file">: filtra o seletor de arquivos do
// sistema. É só uma dica de UX — quem barra de fato é o backend.
export const acceptedFileTypes = (validations) => {
  const mimes = parseMimes(validations);

  return mimes.length ? mimes.join(',') : undefined;
};

// Texto "Tipos de arquivo aceitos: ...". Sem validations mantém a frase antiga, que é o
// caso de todas as telas que ainda não passam o tipo de documento.
export const describeAcceptedFileTypes = (validations) => {
  const mimes = parseMimes(validations);
  const labels = FILE_TYPES
    .filter((type) => type.mimes.some((mime) => mimes.includes(mime)))
    .map((type) => type.label);

  if (!labels.length) return DEFAULT_DESCRIPTION;

  const images = labels.filter((label) => label !== 'PDF');

  if (!images.length) return labels.join(' e ');
  if (!labels.includes('PDF')) return `imagens (${images.join(' e ')})`;

  return `PDF e imagens (${images.join(' e ')})`;
};
